import React, {useState, useEffect, useContext} from "react";

import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";

function SnackProvider(props) {
  const [open, setOpen] = useState(false);
  const [context, setContext] = useState({
    message: "Erfolg!",
    button: "Weiter",
    closeFn: function () {},
  });

  function triggerSnackbar(updated) {
    setOpen(true);
    setContext({...context, ...updated});
  }

  function handleClose(event) {
    setOpen(false);
    context.closeFn();
  }

  return (
    <snackProvider.Provider
      value={{
        triggerSnackbar,
      }}>
      <>
        <Snackbar
          anchorOrigin={{vertical: "bottom", horizontal: "left"}}
          open={open}
          autoHideDuration={6000}
          onClose={() => {
            return handleClose();
          }}
          message={context.message}
          action={
            <>
              <Button color="primary" size="small" onClick={handleClose}>
                {context.button}
              </Button>
              <IconButton
                aria-label="close"
                color="inherit"
                onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </>
          }
        />
        {props.children}
      </>
    </snackProvider.Provider>
  );
}

export default SnackProvider;
export const snackProvider = React.createContext();
